export interface BrowserNotificationLike {
  id: string;
  read: boolean;
  type: string;
  title?: string;
  message?: string;
}

export const getNewNotificationsToPush = (
  seenIds: Set<string>,
  incomingNotifications: BrowserNotificationLike[]
): BrowserNotificationLike[] =>
  incomingNotifications.filter((notification) => {
    const isUnread = !notification.read;
    const isNew = !seenIds.has(notification.id);
    return isUnread && isNew;
  });

export const shouldRequestBrowserNotifications = () => typeof window !== 'undefined' && 'Notification' in window;

export const requestBrowserNotificationPermission = async () => {
  if (!shouldRequestBrowserNotifications()) return 'denied';
  if (window.Notification.permission === 'granted') return 'granted';
  if (window.Notification.permission === 'denied') return 'denied';
  return window.Notification.requestPermission();
};

export const showBrowserNotification = (title: string, body: string) => {
  if (!shouldRequestBrowserNotifications()) return;
  if (window.Notification.permission !== 'granted') return;

  new window.Notification(title, {
    body,
    tag: `kinship-${title.toLowerCase().replace(/\s+/g, '-')}`
  });
};
